import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ChallengeShadowBoxingService } from 'src/app/gamification/command-center/services/challenge-shadow-boxing.service';
import { HP_VALUES } from 'src/app/gamification/command-center/services/challenge-shadow-boxing.service';

@Component({
  selector: 'cv-shadow-boxing-progress',
  templateUrl: './shadow-boxing-progress.component.html',
  styleUrls: ['./shadow-boxing-progress.component.scss']
})

export class ShadowBoxingProgressComponent implements OnChanges {
  @Input() challenge: any;
  @ViewChild('progressContainer', { static: false }) progressContainer!: ElementRef;
  @ViewChild('punchContainer') punchContainer!: ElementRef;
  @ViewChild('todayScore') todayScore!: ElementRef;

  hp: number = 0;
  hpValues = HP_VALUES;
  progressScenarios: { current: number, hp: number }[] = [];
  showTooltip: boolean = false;
  showButtonTooltip: boolean = false;
  showMetricGoalTooltip: boolean = false;
  tooltipStyle: any = {};
  tooltipSource: string = null;
  endDateFormatted: any = null;
  startDateFormatted: any = null;

  constructor(
    private datePipe: DatePipe,
    private shadowBoxingService: ChallengeShadowBoxingService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['challenge']) {
      const challenge = this.challenge;

      if (challenge?.EndDate_ForView) {
        const endDate = new Date(challenge.EndDate_ForView);
        if (!isNaN(endDate.getTime())) {
          this.endDateFormatted = this.datePipe.transform(endDate, 'MM/dd/yyyy');
        } 
      }

      if (challenge?.StartDate_ForView) {
        const startDate = new Date(challenge.StartDate_ForView);
        if (!isNaN(startDate.getTime())) {
          this.startDateFormatted = this.datePipe.transform(startDate, 'MM/dd/yyyy');
        }
      }

      if (challenge?.shadowBoxing) {
        this.hp = challenge.shadowBoxing.Difficulty + 1;
      }

      this.generateProgressScenarios();
    }
  }

  get dailyGoal(): string {
    if (this.challenge?.IsRunning === false) return '---';
    return this.challenge?.shadowBoxing.DailyGoalMetricString || '---';
  }

  get todayScoreValue(): string {
    if (this.challenge?.IsRunning === false) return '---';
    return this.challenge?.Rankings[0].ViewScore === null ? '---' : this.challenge?.Rankings[0].ViewScore;
  }

  get imageSrc(): string {
    if (!this.challenge?.Rankings[0] || !this.challenge?.Rankings[0].ImageTypeID) return `../Admin/ImageResizer.aspx?imgid=${null}`;
    const imageID = this.challenge?.Rankings[0].ImageID > 0 ? this.challenge?.Rankings[0].ImageID : null
    const loginID = this.challenge?.Rankings[0].LoginID;
    const ImageByImageType = {
      1: `../Admin/ImageResizer.aspx?imgid=${imageID}`,
      2: `../Admin/AvatarProfileImage.aspx?loginid=${loginID}`
    };
    return ImageByImageType[this.challenge?.Rankings[0].ImageTypeID] || `../Admin/ImageResizer.aspx?imgid=${null}`;
  }

  generateProgressScenarios() {
    this.progressScenarios = [];
    this.hpValues.forEach(hp => {
      for (let i = 0; i <= hp; i++) {
        this.progressScenarios.push({ current: i, hp });
      }
    });
  }

  getFilteredScenarios(): { current: number, hp: number }[] {
    if (this.challenge?.shadowBoxing) {
      if (this.challenge.shadowBoxing.Punch === undefined) {
        return this.progressScenarios.filter(scenario => scenario.current == 0 && scenario.hp === this.hp);
      } else {
        return this.progressScenarios.filter(scenario => scenario.current === this.challenge.shadowBoxing.Punch && scenario.hp === this.hp);
      }
    }
  }

  getProgressBarStyles(value: number, hp: number): { width: string, backgroundColor: string } {
    const percentage = Math.max(Math.round(((hp - value) / hp) * 100), 0);
    let color = '#EEF0F2';

    if (hp === 2) {
      color = percentage > 50 ? '#2B86EE' : (percentage === 50 ? '#BD2026' : color);
    } else if (hp === 3) {
      if (percentage === 67) color = '#E4B321';
      else if (percentage === 33) color = '#BD2026';
      else if (percentage === 100) color = '#2B86EE';
    } else if (hp === 4) {
      if (percentage === 75) color = '#3D944A';
      else if (percentage === 50) color = '#E4B321';
      else if (percentage === 25) color = '#BD2026';
      else if (percentage === 100) color = '#2B86EE';
    }

    return {
      width: `${percentage}%`,
      backgroundColor: color
    };
  }

  toggleTooltip(show: boolean, source): void {
    if (source == 'punch') this.showButtonTooltip = show
    else if (source == 'today-score') this.showMetricGoalTooltip = show
    else this.showTooltip = show;

    this.tooltipSource = show ? source : null;
    if (show) {
      this.updateTooltipPosition();
    }
  }

  updateTooltipPosition(): void {
    let container: ElementRef | undefined;

    if (this.tooltipSource === 'progress') {
      container = this.progressContainer;
    } else if (this.tooltipSource === 'punch') {
      container = this.punchContainer;
    } else {
      container = this.todayScore;
    }

    if (container) {
      const targetElement = container.nativeElement.querySelector('.progress-bar') || container.nativeElement.querySelector('.punch-button') || container.nativeElement.querySelector('.score-text');
      const tooltipElement = container.nativeElement.querySelector('.health-points-tooltip');

      if (targetElement && tooltipElement) {
        const targetRect = targetElement.getBoundingClientRect();
        const tooltipHeight = tooltipElement.offsetHeight;

        const tooltipTop = targetRect.top + window.scrollY - tooltipHeight;
        let tooltipLeft = targetRect.right + 10;

        this.tooltipStyle = {
          top: `${tooltipTop}px`,
          left: `${tooltipLeft}px`,
          display: 'block'
        };
      }
    }
  }

  async givePunch() {
    if (this.challenge?.shadowBoxing) {
      const shadowBoxing = await this.shadowBoxingService.giveAPunch(this.challenge.ChallengeID);
      if (shadowBoxing)
        this.challenge.shadowBoxing = shadowBoxing;
    }
  };

}
